import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { Card, CardBody, Col } from "reactstrap";
import { StateTableItems } from "../../../../../../types/Tables";
import { ChildRowsTitle } from "../../../../../../constants";
import FilterComponent from "../../common/FilterComponent";
import CustomExpandableComponent from "./CustomExpandableComponent";
import CommonCardHeader from "../../../../../../coreComponents/CommonCardHeader";
import { ChildRowsTableColumns, StateSavingTableData } from "../../../../../../data/formsAndTable/tables/dataTables/BasicInit";
import { ChildrenRowsSubTitle } from "../../../../../../data/formsAndTable/tables/dataTables/API";

const ChildRows = () => {
  const [filterText, setFilterText] = useState("");
  const filteredItems: StateTableItems[] = StateSavingTableData.filter((item: StateTableItems) => Object.values(item).some((value) => value && value.toString().toLowerCase().includes(filterText.toLowerCase())));
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader tag headClass="pb-0 card-no-border" title={ChildRowsTitle} span={ChildrenRowsSubTitle} />
        <CardBody>
          <FilterComponent onFilter={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)} filterText={filterText} />
          <DataTable className="custom-scrollbar" data={filteredItems} columns={ChildRowsTableColumns} pagination expandableRows={true} expandableRowsComponent={CustomExpandableComponent} striped />
        </CardBody>
      </Card>
    </Col>
  );
};
export default ChildRows;
